<template lang="pug">
v-form( ref="regionForm" )
  app-card-title Регион
  app-text-field( v-model="form.title" label="Наименование регион" :rules="[rules.required]" )
  app-text-field( v-model="form.alias" label="Алиас" :rules="[rules.required]" )
  app-text-field( v-model="form.code" label="Код региона" )
</template>

<script>
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  name: "ExpertRegionForm",
  mixins: [$_validate_rules],
  props: {
    form: null,
  },
}
</script>